import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCardFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16.8,
	viewBox: "0 0 20 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 11.5338C0 12.1879 0.263392 12.8152 0.732233 13.2777C1.20107 13.7402 1.83696 14 2.5 14H17.5C18.163 14 18.7989 13.7402 19.2678 13.2777C19.7366 12.8152 20 12.1879 20 11.5338V4.75171H0V11.5338ZM2.94643 8.18678C2.94643 7.83638 3.08753 7.50033 3.3387 7.25256C3.58986 7.00479 3.93051 6.8656 4.28571 6.8656H6.42857C6.78377 6.8656 7.12442 7.00479 7.37559 7.25256C7.62675 7.50033 7.76786 7.83638 7.76786 8.18678V9.06757C7.76786 9.41797 7.62675 9.75402 7.37559 10.0018C7.12442 10.2496 6.78377 10.3888 6.42857 10.3888H4.28571C3.93051 10.3888 3.58986 10.2496 3.3387 10.0018C3.08753 9.75402 2.94643 9.41797 2.94643 9.06757V8.18678Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.5 0H2.5C1.83696 0 1.20107 0.259832 0.732233 0.722336C0.263392 1.18484 0 1.81213 0 2.46621V3.61123H20V2.46621C20 1.81213 19.7366 1.18484 19.2678 0.722336C18.7989 0.259832 18.163 0 17.5 0Z",
		fill: "currentColor"
	})]
});
export default SvgCreditCardFilled;
